import React from 'react';

import { cn } from '@/lib/utils';

interface ChatLogoProps {
  size?: number | string;
  className?: string;
  color?: string;
}

export function ChatLogo({ size = 32, className, color = 'currentColor' }: ChatLogoProps) {
  return (
    <div style={{ width: size, height: size }} className={cn('shrink-0', className)}>
      <svg width="100%" height="100%" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M89.3807 57.3232C78.8995 48.4005 69.8719 38.5554 62.3934 28C56.719 30.8492 51.4502 34.3872 46.6981 38.5058C55.3024 50.8448 65.5666 62.1029 77.1591 71.9277C88.3066 81.3338 105.055 81.2954 116.174 71.8642C127.894 61.8706 138.061 50.7613 146.514 38.7793C141.748 34.6039 136.457 31.0147 130.752 28.124C123.291 38.6324 114.3 48.4356 103.877 57.3232C99.6964 60.8505 93.5612 60.8506 89.3807 57.3232Z"
          fill={color}
        />
        <path
          d="M134.637 88.1968C143.559 77.7156 153.405 68.6879 163.96 61.2095C161.111 55.5351 157.573 50.2663 153.454 45.5142C141.115 54.1185 129.857 64.3826 120.032 75.9751C110.626 87.1226 110.665 103.871 120.096 114.99C130.089 126.71 141.199 136.877 153.181 145.33C157.356 140.564 160.945 135.273 163.836 129.568C153.328 122.108 143.524 113.116 134.637 102.693C131.109 98.5124 131.109 92.3772 134.637 88.1968Z"
          fill={color}
        />
        <path
          d="M104.133 135.151C114.614 144.074 123.642 153.919 131.12 164.474C136.795 161.625 142.063 158.087 146.815 153.968C138.211 141.629 127.947 130.371 116.354 120.547C105.207 111.14 88.4581 111.179 77.3398 120.61C65.6193 130.604 55.4529 141.713 47 153.695C51.7651 157.87 57.0563 161.46 62.7617 164.35C70.2221 153.842 79.2133 144.039 89.6367 135.151C93.8172 131.624 99.9524 131.624 104.133 135.151Z"
          fill={color}
        />
        <path
          d="M58.3232 102.647C49.4005 113.128 39.5554 122.156 29 129.634C31.8492 135.309 35.3872 140.577 39.5058 145.33C51.8448 136.725 63.1029 126.461 72.9277 114.869C82.3338 103.721 82.2954 86.9723 72.8642 75.854C62.8706 64.1335 51.7613 53.967 39.7793 45.5142C35.6039 50.2793 32.0147 55.5705 29.124 61.2759C39.6324 68.7362 49.4356 77.7274 58.3232 88.1509C61.8505 92.3314 61.8506 98.4665 58.3232 102.647Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
